var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.927246H513V342.894H0V0.927246Z",
    fill: "#12AD2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.927246V167.953L0 172.061V0.927246H513Z",
    fill: "#6AB2E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 171.961L0 342.894V0.927246L256.5 171.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9754 93.6079L107.009 146.11H162.316L117.629 178.674L134.663 231.176L89.9754 198.713L45.2883 231.176L62.3215 178.674L17.6344 146.11H72.9422L89.9754 93.6079Z",
    fill: "#D7141A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 341.967,
    fill: "white",
    transform: "translate(0 0.927246)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/DJ.9d98a36b3bc25dad44b4e357d5c237c1.svg";
export { ForwardRef as ReactComponent };